import React from 'react';
import { connect } from 'react-redux';

import * as Constants from '../../Common/constants.js';


import API from '../../Api/leaderboard';
import * as Utils from '../../Common/utils.js';
import './PlayerPage.css'; // Tell Webpack that Button.js uses these styles
import HoleItem from '../HoleItem/HoleItem.js';
import Player from './Player.js';

class PlayerPage extends React.Component {

    constructor(props) {

        super(props);

        let params = Utils.getQueryParams(this.props.location.search);
        this.player_id = params["id"];


        this.state = { data: null, serverErrors: {}};

        console.info('PlayerPage - constructor called.');


    }
    static getDerivedStateFromProps(props, state) {
        console.info('PlayerPage - getDerivedStateFromProps called.');


        var lastEvent = props.leaderboardData.last;
        if (!lastEvent) {
            return null;
        } else {
            return {
                last: lastEvent,
                prevEvent: state.last   
            };
        }

    } 

    componentDidMount() {
        console.info('PlayerPage - componentDidMount called.');
        this.fetchPlayer(this.player_id);
     
        
        this.myInterval = setInterval(() =>  this.fetchPlayer(this.player_id), 30000);

    }





     componentDidUpdate(prevProps, prevState) {
        if (!this.state.last){
            return null;
        }
        let player = this.state.data.player;
      
        if (this.state.last.holeIndex > player.currentHole) {
            console.log("reload");
            
            this.fetchPlayerEvents(player);
            
        }
    } 
    loadPlayerData(lastevent) {
        let data = this.state.data;
        data.players.forEach(player => {

            if (player.id === lastevent.playerId) {
                this.fetchPlayerEvents(player);
            }


        });
    }

    componentWillUnmount() {
        clearInterval(this.myInterval);
    }


    render() {
        console.info('PlayerPage - render called.');


        if (this.state.data) {
            let player = this.state.data.player;
            this._currenthole = player.currentHole;
            let players =[player];
            return (
                <div><img style={{width:'2.2em'}} src={require('../../images/back_arrow.png')} onClick={() => this.props.history.goBack()}></img>
                    <div className="container">

                       
                        <Player key={this.playerid} data={player} haslastitem={true} leaderboard={this.props.leaderboardData} />

                        {<HoleItem players={players} holeindex={this._currenthole} width={375} height={675} strokes={[]} />
                        }
                        
                    </div>
                </div>);

        } else {
            return (<div>Loading data...</div>);
        }
    }




    fetchPlayerEvents(player) {

        console.log(" fetchPlayerEvents", player);
        let roundIndex = Utils.getRoundIndex(player);
        let holeIndex = Utils.getHoleIndex(player);
        let url = Constants.SERVER + "/playerevent?playerId=" + player.id + "&roundIndex=" + roundIndex + "&holeIndex=" + holeIndex;
        console.log(" fetchPlayerEvents", url);
        fetch(url)
            .then(response => response.json())
            .then(data => {

                    this.setState({ ...this.state, events: data });
            }


            ).catch((error) => {
                console.log("error when fetfetchPlayerEvents", url);
                console.error(error);
            });;

    }

    fetchPlayer(id) {

        console.log(" fetchPlayer", id);
        let url = Constants.SERVER + "/player/" + id;
        console.log(" fetchPlayer", url);
        fetch(url)
            .then(response => response.json())
            .then(data => {
                console.log("data", data);
                    this.setState({ ...this.state, data: data });
            }


            ).catch((error) => {
                console.log("error when fetfetchPlayerEvents", url);
                console.error(error);
            });;

    }


}

/**
 * Get data from store
 * @param state
 */
const mapStateToProps = state => ({
    userData: state.userData,
    leaderboardData: state.leaderboard,

});

/**
 * Import action from dir action above - but must be passed to connect method in order to trigger reducer in store
 * @type {{UserUpdate: UserUpdateAction}}
 */
const mapActionsToProps = {

};

export default connect(mapStateToProps, mapActionsToProps)(PlayerPage);

function getStrokesHole(){
    return [];
}


// WEBPACK FOOTER //
// ./src/Components/PlayerPage/index.js